 <template>
    <div class="chequeosStatusBar">
        <strong>Último chequeo: </strong>
        <span class="ultimoChequeoHora">{{ ultimoChequeoHora }}</span>
        <ProgressSpinner class="chequeandoSpinner" strokeWidth="8" fill="#eee" animationDuration="1.5s" v-if="chequeando" />
        <span class="chequeandoAviso" v-if="chequeando">Chequeando ...</span>
    </div>
    <div class="p-grid p-fluid dashboard">
        <div class="p-col-12 p-lg-4">
            <div class="card summary">
                <span class="title link" @click="$router.push({ name: 'usuarios_admin' })">Usuarios</span>
                <span class="detail ellipsis" v-html="usuarios?.length > 0 ? `Último usuario agregado <strong>${fechaFormateada(ultimoUsuario.created_at)}</strong>` : '&nbsp;'"></span>
                <span class="count purchases">
                    {{
                        usuarios ? usuarios.length : ''
                    }}
                    <ProgressSpinner class="cargandoSpinner" strokeWidth="8" animationDuration="1.5s" v-if="usuarios === null" />
                </span>
            </div>
        </div>
        <div class="p-col-12 p-lg-4">
            <div class="card summary">
                <span class="title link" @click="$router.push({ name: 'clientes_admin' })">Clientes</span>
                <span class="detail ellipsis" v-html="clientes?.length > 0 ? `Último cliente agregado <strong>${fechaFormateada(ultimoCliente.created_at)}</strong>` : '&nbsp;'"></span>
                <span class="count visitors">
                    {{
                        clientes ? clientes.length : ''
                    }}
                    <ProgressSpinner class="cargandoSpinner" strokeWidth="8" animationDuration="1.5s" v-if="clientes === null" />
                </span>
            </div>
        </div>
        <div class="p-col-12 p-lg-4">
            <div class="card summary">
                <span class="title link" @click="$router.push({ name: 'proveedores_admin' })">Proveedores</span>
                <span class="detail ellipsis" v-html="proveedores?.length > 0 ? `Último proveedor agregado <strong>${fechaFormateada(ultimoProveedor.created_at)}</strong>` : '&nbsp;'"></span>
                <span class="count revenue">
                    {{
                        proveedores ? proveedores.length : ''
                    }}
                    <ProgressSpinner class="cargandoSpinner" strokeWidth="8" animationDuration="1.5s" v-if="proveedores === null" />
                </span>
            </div>
        </div>
        <!-- <div class="p-col-12 p-lg-6">
            <div class="card summary">
                <span class="title link" @click="$router.push({ name: 'consumos' })">Consumos</span>
                <span class="detail">{{ mesActual }}</span>
                <span class="count consumos">
                    {{
                        consumosMesActual !== null ? `$${consumosMesActual.toLocaleString('es-ar')}` : ''
                    }}
                    <ProgressSpinner class="cargandoSpinner" strokeWidth="8" animationDuration="1.5s" v-if="consumosMesActual === null" />
                </span>
            </div>
        </div>
        <div class="p-col-12 p-lg-6">
            <div class="card summary">
                <span class="title link" @click="$router.push({ name: 'consumos' })">Comisiones</span>
                <span class="detail">{{ mesActual }}</span>
                <span class="count comisiones">
                    {{
                        comisionesMesActual !== null ? `$${comisionesMesActual.toLocaleString('es-ar')}` : ''
                    }}
                    <ProgressSpinner class="cargandoSpinner" strokeWidth="8" animationDuration="1.5s" v-if="comisionesMesActual === null" />
                </span>
            </div>
        </div> -->
        <!-- <div class="p-col-12 p-lg-4">
            <Panel header="Documentación" style="height: 100%">
                <ul class="activity-list" style="max-height: 340px; overflow: auto">
                    <li v-for="cliente in clientes" :key="cliente.id">
                        <div class="p-d-flex p-jc-between p-ai-center p-mb-3">
                            <div style="width: calc(100% - 120px)">
                                <h5 class="clienteNombre activity p-m-0">{{ cliente.nombre }}</h5>
                                <p class="clientesTipoNombre">{{ cliente.documentos_set.nombre }}</p>
                            </div>
                            <div class="count" style="width: 90px; text-align: center" :style="{ backgroundColor: `${colorDocumentos(cliente)}` }">
                                {{ cliente.documentosAprobados }}/{{ cliente.documentosTotal }}
                            </div>
                        </div>
                        <ProgressBar :value="porcentaje(cliente)" :showValue="false" />
                    </li>
                </ul>
            </Panel>
        </div>-->
        <!-- <div class="p-col-12 p-lg-12">
            <div class="card">
                <Chart type="line" :data="lineData" />
            </div>
        </div> -->
    </div>
</template>

<script>
import UsuariosService from '../../service/UsuariosService'
import ClientesService from '../../service/ClientesService'
import ProveedoresService from '../../service/ProveedoresService'
// import ConsumosService from '../../service/ConsumosService'
import moment from 'moment'
import { capitalizeFirstLetter } from '../../resources/helpers'

export default {
    name: 'InicioAdmins',
    data() {
        return {
            chequeoTimer: null,
            chequeando: false,
            ultimoChequeoHora: '-',
            usuarios: null,
            clientes: null,
            proveedores: null,
            consumos: null,
            lineData: null,
            consumosMesActual: null,
            comisionesMesActual: null,
            mesActual: '',
            mesActualInicio: null,
            mesActualFin: null,
            consumosMaxId: 0,
        }
    },
    async mounted() {
        this.mesActual = capitalizeFirstLetter(moment().format('MMMM YYYY'))
        this.mesActualInicio = moment().startOf('month')
        this.mesActualFin = moment().endOf('month')

        this.procesarStats()
        this.chequeoTimer = setInterval(() => {
            this.procesarStats()
        }, 30000)
    },
    unmounted() {
        clearInterval(this.chequeoTimer)
    },
    computed: {
        ultimoUsuario: function () {
            return this.usuarios[this.usuarios.length - 1]
        },
        ultimoCliente: function () {
            return this.clientes[this.clientes.length - 1]
        },
        ultimoProveedor: function () {
            return this.proveedores[this.proveedores.length - 1]
        },
    },
    methods: {
        fechaFormateada(fecha) {
            return moment(fecha).fromNow()
        },
        async procesarStats() {
            this.chequeando = true

            this.clientes = (await ClientesService.get({ first: 0, rows: 5000, sortField: 'id', sortOrder: 1, filters: '' })).clientes.filter(
                (cliente) => cliente.nombre !== '',
            )
            this.proveedores = (await ProveedoresService.get({ first: 0, rows: 5000, sortField: 'id', sortOrder: 1, filters: '' })).proveedores.filter(
                (proveedor) => proveedor.nombre !== '',
            )
            this.usuarios = (await UsuariosService.get({ first: 0, rows: 5000, sortField: 'id', sortOrder: 1, filters: '', nivel: 6 })).usuarios.filter(
                (usuario) => usuario.nombre !== '',
            )
            this.consumos = [];//(await ConsumosService.get({ first: 0, rows: 5000, sortField: 'created_at', sortOrder: 1, filters: '', estado: 2 })).consumos

            let consumosMesActual = 0
            let comisionesMesActual = 0

            const consumosPorFecha = {}
            let consumosInicio = null;

            let actualizarChart = false

            this.consumos.forEach((consumo) => {
                if (consumo.id > this.consumosMaxId) {
                    this.consumosMaxId = consumo.id
                    actualizarChart = true
                }

                const fechaConsumo = moment(consumo.created_at)
                const fechaConsumoStr = fechaConsumo.format('D MMM').toUpperCase().replace('.', '')

                if (consumosInicio === null) {
                    consumosInicio = fechaConsumo;
                }

                const monto = consumo.monto
                const comision = (monto / 100) * consumo.comision

                if (typeof consumosPorFecha[fechaConsumoStr] === 'undefined') {
                    consumosPorFecha[fechaConsumoStr] = []
                }

                consumosPorFecha[fechaConsumoStr].push({
                    monto,
                    comision,
                })

                if (fechaConsumo.isBetween(this.mesActualInicio, this.mesActualFin)) {
                    consumosMesActual += monto
                    comisionesMesActual += comision
                }
            })

            this.consumosMesActual = consumosMesActual
            this.comisionesMesActual = comisionesMesActual

            if (actualizarChart === true) {
                const lineData = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Consumos',
                            data: [],
                            fill: false,
                            backgroundColor: '#00bb7e',
                            borderColor: '#00bb7e',
                            tension: 0.3,
                        },
                        {
                            label: 'Comisiones',
                            data: [],
                            fill: false,
                            backgroundColor: '#2f4860',
                            borderColor: '#2f4860',
                            tension: 0.3,
                        },
                    ],
                }

                const hoy = moment()

                for (var m = moment(consumosInicio); m.isBefore(hoy); m.add(1, 'days')) {
                    const fechaStr = m.format('D MMM').toUpperCase().replace('.', '')
                    lineData.labels.push(fechaStr)

                    const consumos = consumosPorFecha[fechaStr]

                    let consumosTotal = 0
                    let comisionesTotal = 0

                    if (consumos) {
                        consumos.map((consumo) => {
                            consumosTotal += consumo.monto
                            comisionesTotal += consumo.comision
                        })
                    }

                    lineData.datasets[0].data.push(consumosTotal)
                    lineData.datasets[1].data.push(comisionesTotal)

                }

                this.lineData = lineData
            }

            this.ultimoChequeoHora = moment().format('HH:mm:ss')

            this.chequeando = false
        },
        porcentaje(cliente) {
            return (cliente.documentosAprobados * 100) / cliente.documentosTotal
        },
        colorDocumentos(cliente) {
            const porcentaje = this.porcentaje(cliente)

            if (porcentaje < 30) {
                return 'red'
            }
            if (porcentaje < 80) {
                return '#f9c851'
            }

            return '#20d077'
        },
    },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 960px) {
    ::v-deep(.p-datatable) {
        &.p-datatable-customers {
            .p-datatable-thead > tr > th,
            .p-datatable-tfoot > tr > td {
                display: none !important;
            }

            .p-datatable-tbody > tr {
                border-bottom: 1px solid #dee2e6;
                > td {
                    text-align: left;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 0 none !important;
                    width: 100% !important;
                    float: left;
                    clear: left;
                    border: 0 none;

                    .p-column-title {
                        padding: 0.4rem;
                        min-width: 30%;
                        display: inline-block;
                        margin: -0.4rem 1rem -0.4rem -0.4rem;
                        font-weight: bold;
                    }

                    .p-progressbar {
                        margin-top: 0.5rem;
                    }
                }
            }
        }
    }
}

.cargandoSpinner {
    width: 18px;
    height: 18px;
}

.clientesTipoNombre {
    font-size: 12px;
    line-height: 13px;
    color: #666;
}

.chequeosStatusBar {
    width: 100%;
    height: 36px;
    line-height: 36px;
    margin-top: 0;
    margin-bottom: 30px;
    background-color: #e6e6e6;
    border-bottom: 1px solid #666;
    z-index: 1;
    text-align: left;
    padding-left: 16px;
}
.chequeandoSpinner {
    width: 18px;
    height: 18px;
    margin-left: 10px;
}
.chequeandoAviso {
    font-size: 12px;
    line-height: 20px;
    margin-left: 5px;
    vertical-align: 2px;
    display: inline-block;
}

.ultimoChequeoHora {
    color: #666;
}

.detail {
    padding-right: 60px;
}

.title.link {
    text-decoration: underline;
    cursor: pointer;
}
</style>
